/**
 * Support Module
 * Módulo de soporte técnico para debugging y monitoreo.
 * Solo accesible para usuarios con códigos en REACT_APP_SUPPORT_EMPLOYEES.
 */
import SupportPage from "./pages/SupportPage";

export default SupportPage;
